import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Sparkles, Truck, Crown, Palette } from 'lucide-react';
import { getAnnouncements } from '../lib/api';

const ICONS = [Truck, Crown, Sparkles, Palette];
const FALLBACK = [
  'Free U.S. Shipping on orders over $300',
  'New: Imperial Luxe & Silk Dynasty bundles now available',
  'Restocked — HD Lace Frontals & Closures',
  'Custom color bundles — made just for you',
];

const AnnouncementBar = () => {
  const [messages, setMessages] = useState(FALLBACK);
  const [i, setI] = useState(0);

  useEffect(() => {
    getAnnouncements().then((d) => { if (d.items?.length) setMessages(d.items); }).catch(() => {});
  }, []);

  useEffect(() => {
    setI(0);
    if (messages.length < 2) return;
    const t = setInterval(() => setI((p) => (p + 1) % messages.length), 4000);
    return () => clearInterval(t);
  }, [messages]);

  const Icon = ICONS[i % ICONS.length];
  return (
    <div className="bg-[#0b0b0b] border-b border-[#c6a15b]/25 h-9 flex items-center justify-center overflow-hidden relative" data-testid="announcement-bar">
      <AnimatePresence mode="wait">
        <motion.div
          key={i + (messages[i] || '')}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-2 overline text-[0.6rem] sm:text-[0.65rem] text-[#e7d3a1] px-4 text-center">
          <Icon size={13} className="text-[#c6a15b] shrink-0" />
          <span className="truncate max-w-[85vw]">{messages[i]}</span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AnnouncementBar;
